import { createFileRoute } from '@tanstack/react-router';

import { Breadcrumb } from '@/components/breadcrumb';
import { ModuleHero } from '@/components/module-hero';

export const Route = createFileRoute('/_auth/customer/locations/$locationId/preview/$moduleType/')({
    component: RouteComponent,
});

function RouteComponent() {
    const params = Route.useParams();

    return (
        <>
            <div className="max-w-screen-2xl flex flex-col flex-1 p-8 pb-0 overflow-y-auto h-full">
                <Breadcrumb
                    items={[{
                        isActive: true,
                        name: 'Object naam',
                        to: '/customer/locations/$locationId',
                        params: { locationId: params.locationId },
                    }]}
                />
                <ModuleHero moduleType={params.moduleType} />
            </div>
        </>
    );
}
